export default class Recommendation {
    constructor(r) {
        this.item = {};
        if(r != false) {
            this.item = r;
        }

        this.defaults();
    }

    isset(key) {
        if(typeof this.item[key] === 'undefined') {
            return false;
        }

        return true;
    }

    output() {
        return this.item;
    }

    defaults() {

        if(!this.isset('text_color')) {
            this.item.text_color = 'inherit';
        }

        if(!this.isset('text_size')) {
            this.item.text_size = 'inherit';
        }

        if(!this.isset('text_font')) {
            this.item.text_font = 'inherit';
        }

        if(!this.isset('button_text')) {
            this.item.button_text = 'Buy now';
        }

        if(!this.isset('button_background')) {
            this.item.button_background = '#4e97d9';
        }

        if(!this.isset('rows')) {
            this.item.rows = 1;
        }

        if(!this.isset('padding')) {
            this.item.padding = '10px 10px 10px 10px';
        }

        if(!this.isset('type')) {
            this.item.type = 'Relevant';
        }


        if(!this.isset('id')) {
            this.item.id = false;
        }


    }
}


// WEBPACK FOOTER //
// ./helpers/recommendation.js